import * as fb from '@/firebase';

export class EmailSignupActions {
  public static recordEmail(
    email: string
  ): Promise<firebase.firestore.DocumentReference> {
    return fb.emailsCollection.add({
      email,
      ts: new Date().getTime()
    });
  }
}
